import { env } from 'utils/envManager'
import { AWSSecretsManager } from 'utils/secretsManager'

const APPLICATION = 'genesis'

export type AkamaiHeader = Record<string, string>

let credentialsData: AkamaiHeader

const AKAMAI_HEADER_SECRET_ARN =
	'arn:aws:secretsmanager:eu-west-1:687762684238:secret:all/common/mango-header-VMH2hQ'

/**
 * @deprecated The method should not be used
 */
export async function getHeaderAkamai(): Promise<AkamaiHeader> {
	if (credentialsData) {
		return credentialsData
	}

	try {
		const isLocal = env.NEXT_PUBLIC_ENV === 'local'

		if (isLocal) {
			return {}
		}

		const { credentials } = await AWSSecretsManager(AKAMAI_HEADER_SECRET_ARN)

		if (credentials) {
			const { name, value } = credentials
			credentialsData = {
				[name]: `${value}${APPLICATION}`,
			}
			return credentialsData
		}
		throw new Error('Error Secrets Manager - all/common/mango-header not found')
	} catch (err) {
		throw new Error('Error Secrets Manager - all/common/mango-header' + err)
	}
}
